import api from '@/api';

const initialState = {
  tiposGravedadPotencial: [],

  tiposDeteccion: [],
};

const getters = {
  incendios: (state, getters, rootState, rootGetters) =>
    rootGetters['emergencia/emergencias'].filter((e) => e.INCENDIO).map((e) => e.INCENDIO),

  getIncendioByID: (state, getters) => (idIncendio) => {
    let incendio = null;

    if (idIncendio) {
      incendio = getters.incendios.find((x) => x.ID_INCENDIO.equalsIgnoreCase(idIncendio));
    }
    return incendio;
  },

  tiposGravedadPotencial: (state) => state.tiposGravedadPotencial,

  tiposDeteccion: (state) => state.tiposDeteccion,

  getTipoDeteccionById: (state) => (idTipoDeteccion) => {
    let deteccion = null;

    if (idTipoDeteccion) {
      deteccion = state.tiposDeteccion.find((x) => x.ID_TIPO_DETECCION === idTipoDeteccion); // TODO: por algun motivo no es uuid, es numerico
    }
    return deteccion;
  },
};

const mutations = {
  SET_TIPOS_GRAVEDAD_POTENCIAL(state, tiposGravedadPotencial) {
    state.tiposGravedadPotencial = tiposGravedadPotencial;
  },

  SET_TIPOS_DETECCION(state, tiposDeteccion) {
    state.tiposDeteccion = tiposDeteccion;
  },
};

const actions = {
  async fetchTiposGravedadPotencial({ commit }) {
    try {
      const response = await api.incendio.getTipoGravedadPotencial();
      commit('SET_TIPOS_GRAVEDAD_POTENCIAL', response.data);
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  async fetchTiposDeteccion({ commit }) {
    try {
      const response = await api.incendio.getTiposDeteccion();
      commit('SET_TIPOS_DETECCION', response.data);
    } catch (err) {
      console.error(err);
    }
  },
  // ESTADOS INCENDIO

  async addGravedadPotencialIncendio({ _commit }, data) {
    try {
      await api.incendio.addGravedadPotencialIncendio(data);
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  // #region ALINEACIONES CAMPBELL
  async editAlineacionesCampbell({ _commit }, data) {
    try {
      await api.incendio.editAlineacionesCampbell(data);
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  // #endregion
};

const module = {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export default module;
